<nav class="bpz-navbar">
  <div class="bpz-navbar-contain">
    <!-- LEFT: Logo -->
    <div *ngIf="showLogo" class="bpz-navbar-brand">
      <ng-container *ngIf="isAuthenticated(); else nonClickableLogo">
        <ng-container *ngIf="!isCompanyProfile">
          <a [routerLink]="['/main', id]" class="bpz-brand-link">
            <img [src]="getLogo()" alt="Logo" class="bpz-logo" />
          </a>
        </ng-container>

        <ng-container *ngIf="isCompanyProfile && !isAgencyProfile">
          <a [routerLink]="['/companyDashboard', companyId]" class="bpz-brand-link">
            <img [src]="getLogo()" alt="Logo" class="bpz-logo" />
          </a>
        </ng-container>

        <ng-container *ngIf="isAgencyProfile">
          <a [routerLink]="['/agencyDashboard']" class="bpz-brand-link">
            <img [src]="getLogo()" alt="Logo" class="bpz-logo" />
          </a>
        </ng-container>
      </ng-container>

      <ng-template #nonClickableLogo>
        <a [routerLink]="['/login']" class="bpz-brand-link">
          <img [src]="getLogo()" alt="Logo" class="bpz-logo disabled-logo" />
        </a>
      </ng-template>
    </div>

    <!-- CENTER: (optional) nav links placeholder like BPZ UI (keep empty if you don't need it) -->
    <!--
    <ul class="bpz-navbar-nav" *ngIf="!(breakpoints$ | async)?.s">
      <li><a class="bpz-navbar-link bpz-navbar-link-active">Link</a></li>
    </ul>
    -->

    <!-- RIGHT: actions (auth buttons OR profile) -->
    <div class="bpz-navbar-actions">
      <!-- Not authenticated buttons -->
      <div *ngIf="showButtons && !(breakpoints$ | async)?.s" class="bpz-actions-auth">
        <app-button
          (click)="openLoginPopup()"
          [label]="'auth.login' | translate"
          [size]="ButtonSize.LARGE"
          [state]="ButtonState.REGULAR"
          [type]="ButtonType.SECONDARY">
        </app-button>

        <app-button
          (click)="openRegistrationPage()"
          [label]="'auth.register' | translate"
          [size]="ButtonSize.LARGE"
          [state]="ButtonState.REGULAR"
          [type]="ButtonType.PRIMARY">
        </app-button>
      </div>

      <!-- Authenticated profile / notifications -->
      <div *ngIf="showProfilePicture" class="bpz-actions-user">
        <ng-container *ngIf="showConsultationCta">
          <!-- AVAILABLE: book button -->
          <button
            *ngIf="consultationStatus === StepStatus.AVAILABLE"
            class="bpz-consultation-cta"
            (click)="openConsultationModal()">
            <mat-icon>calendar_today</mat-icon>
            {{ 'pricing.step2.action' | translate }}
          </button>

          <!-- PENDING_VALIDATION: booked, awaiting admin -->
          <div *ngIf="consultationStatus === StepStatus.PENDING_VALIDATION" class="bpz-consultation-cta bpz-cta-pending">
            <mat-icon>event</mat-icon>
            {{ 'pricing.statusPendingValidation' | translate }}
          </div>

          <!-- IN_PROGRESS: admin confirmed -->
          <div *ngIf="consultationStatus === StepStatus.IN_PROGRESS" class="bpz-consultation-cta bpz-cta-confirmed">
            <mat-icon>check_circle</mat-icon>
            {{ 'consultationBanner.statusConfirmed' | translate }}
          </div>

          <!-- COMPLETED: next step unlocked -->
          <div *ngIf="consultationStatus === StepStatus.COMPLETED" class="bpz-consultation-cta bpz-cta-completed">
            <mat-icon>lock_open</mat-icon>
            {{ 'consultationBanner.statusNextStep' | translate }}
          </div>
        </ng-container>
        <div *ngIf="isInboxPresent && !(breakpoints$ | async)?.s" class="bpz-icon-container">
          <button (click)="toggleNotificationsPanel()" mat-icon-button class="bpz-icon-btn">
            <span *ngIf="hasNotifications()" class="unread-badge">+{{ totalNotifications }}</span>
            <mat-icon>notifications_active</mat-icon>
          </button>

          <app-notification-panel
            *ngIf="showNotificationsPanel"
            class="bpz-notification-panel"
            [notifications]="notifications"
            (close)="toggleNotificationsPanel()">
          </app-notification-panel>

          <button (click)="navigateToHome()" mat-icon-button class="bpz-icon-btn">
            <mat-icon>home</mat-icon>
          </button>

          <button (click)="navigateToPricing()" mat-icon-button class="bpz-icon-btn">
            <mat-icon>lock</mat-icon>
          </button>
        </div>

        <button [matMenuTriggerFor]="profileMenu" class="pm-trigger-btn" [class.loading]="!isImageLoaded">
          <img
            class="mentor-image"
            (load)="onImageLoad()"
            loading="lazy"
            [src]="imageUrl"
            alt="Profile Picture"
          />
          <mat-icon class="pm-chevron">expand_more</mat-icon>
        </button>

        <mat-menu
          xPosition="before"
          yPosition="below"
          panelClass="profile-menu-panel"
          #profileMenu="matMenu">


          <!-- Navigation items -->
          <ng-container *ngIf="!isCompanyProfile">
            <button mat-menu-item (click)="navigateToMyProfile()">
              <mat-icon>person_outline</mat-icon>
              <span>{{ 'menu.my_overview' | translate }}</span>
            </button>
            <button mat-menu-item (click)="navigateToMyApplications()">
              <mat-icon>work_outline</mat-icon>
              <span>{{ 'menu.my_applications' | translate }}</span>
            </button>
          </ng-container>

          <ng-container *ngIf="isCompanyProfile && !isAgencyProfile">
            <button mat-menu-item (click)="navigateToCompanyHome()">
              <mat-icon>business</mat-icon>
              <span>{{ 'menu.my_company' | translate }}</span>
            </button>
            <button mat-menu-item (click)="navigateToJobs()">
              <mat-icon>work_outline</mat-icon>
              <span>{{ 'menu.my_jobs' | translate }}</span>
            </button>
          </ng-container>

          <ng-container *ngIf="isAgencyProfile">
            <button mat-menu-item (click)="navigateToAgencyHome()">
              <mat-icon>business</mat-icon>
              <span>{{ 'menu.my_company' | translate }}</span>
            </button>
          </ng-container>

          <ng-container *ngIf="!isMobile">
            <button mat-menu-item (click)="navigateTo('settings')">
              <mat-icon>settings</mat-icon>
              <span>{{ 'menu.settings' | translate }}</span>
            </button>
          </ng-container>

          <div class="pm-divider"></div>

          <button mat-menu-item class="pm-logout" (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>{{ 'auth.logout' | translate }}</span>
          </button>

        </mat-menu>
      </div>
    </div>
  </div>
</nav>
